import { CARGA_ABORDAJE } from "../constants/actions-types";

const defaultExploracion = {
	casoActual:-1,
	abordajeActual:-1,
};

function exploracionReducer(state = defaultExploracion,action){
	if(action.type === CARGA_ABORDAJE){
		let newState = {...state};
		newState.casoActual = action.numAbordaje.caso;
		newState.abordajeActual = action.numAbordaje.abordaje;
		return newState;
	}
	return state;
}

export default exploracionReducer;